export default "__VITE_ASSET__DCTYzuzM__"